import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/packages/login/src/app/global-error.tsx");
